import { transparentize } from "polished";

export const colors = {
  primary: {
    100: "#4E5DC5",
    200: "#424FAE",
    300: "#3A469F",
    400: "#323E91",
    600: "#2B336D",
    800: "#252A4F",
  },
  secondary: {
    100: "#fff5f5",
    200: "#fed7d7",
    300: "#feb2b2",
    400: "#fc8181",
    500: "#f56565",
    600: "#e53e3e",
    700: "#c53030",
    800: "#9b2c2c",
    900: "#742a2a",
  },
  gray: {
    100: "#f7fafc",
    200: "#edf2f7",
    300: "#e2e8f0",
    400: "#cbd5e0",
    500: "#a0aec0",
    600: "#718096",
    700: "#4a5568",
    800: "#2d3748",
    900: "#1a202c",
  },
  black: "#2d3748",
  white: "#FFFFFF",
};

export const gradient = {
  primary: `linear-gradient(70deg,${colors.primary[400]} 50%,${colors.primary[100]} 100%)`,
  secondary: `linear-gradient(70deg, ${colors.secondary[800]} 20%, ${transparentize(
    0.2,
    colors.secondary[400]
  )} 100%);`,
};
